module.exports = __webpack_public_path__ + "static/media/pagaPos.f1babe9d.svg";